import { Direction, Log_Allow } from "./SnpChatConstant";

//Private access



function getRandomBetween3AndMax(max) {
    if (max < 3) {
        throw new Error("Max must be at least 3");
    }
    return Math.floor(Math.random() * (max - 3 + 1)) + 3;
}

function countDigits(n) {
    if (n === 0) return 1;
    return Math.floor(Math.log10(Math.abs(n))) + 1;
}

function extractLastNDigits(s) {
    if (!s || s.length < 2) return ["", 0];

    const countChar = s[0];
    if (!/^[1-9]$/.test(countChar)) return ["", 0];

    const count = parseInt(countChar, 10);
    const body = s.slice(1);

    if (body.length < count) return ["", 0];

    const lastPart = body.slice(-count);
    if (!/^\d+$/.test(lastPart)) return ["", 0];

    const remaining = body.slice(0, -count);
    const removedNumber = parseInt(lastPart, 10);

    return [remaining, removedNumber];
}

function jumbleString(input) {
    const level = input.length / 2;
    let parts = [input.substring(0, level), input.substring(level)];
    return (
        parts[0].split("").reverse().join("") +
        parts[1].split("").reverse().join("")
    );
}

//Exported/Public access

function printChatDebugLog(first, ...msg) {
    if (!Log_Allow.DEBUG_ENABLED) return;
    console.log(first, msg);
}

function isEmptyData(val) {
    if (val === undefined) return true;
    if (val === null) return true;
    return (val.length <= 0) ? true : false;
}

function getHighPrecisionTimestamp() {
    const now = Date.now();
    const perf = Math.floor((performance.now() % 1) * 1e6);
    return now * 1e6 + perf;
}

function getRandomTwoDigitNumber() {
    return Math.floor(Math.random() * 90) + 10;
}

function encodeWithDigit(input, digit) {
    digit = getRandomBetween3AndMax(digit)
    input = jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
        const c = input.charCodeAt(index) + digit;
        word = word + String.fromCharCode(c);
    }
    word = countDigits(digit) + word + digit;
    // const decoded = decodeWithDigit(word);
    // printDebugLog("encodeWithDigit", `Encoded: ${input} with digit: ${digit} to ${word} & decoded back to: ${decoded}`);
    return word;
}
function decodeWithDigit(input) {
    if (isEmptyData(input)) return input;
    const resArr = extractLastNDigits(input);
    input = resArr[0];
    const digit = resArr[1];
    let org = "";
    if (digit > 0) {
        for (let index = 0; index < input.length; index++) {
            const c = input.charCodeAt(index) - digit;
            org = org + String.fromCharCode(c);
        }
        org = jumbleString(org);
    }
    return org;
}

function getMsgFrom(msgFrom, direction) {
    if (isEmptyData(msgFrom)) {
        return direction === Direction.RIGHT ? "You" : "Support";
    }
    return direction === Direction.RIGHT ? `You (${msgFrom})` : msgFrom;
}

export {
    printChatDebugLog,
    isEmptyData,
    getRandomTwoDigitNumber,
    encodeWithDigit,
    decodeWithDigit,
    getHighPrecisionTimestamp,
    getMsgFrom
}